import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import '../../css/Dashboard.css';
import { useDashboardData } from '../SalesDashboard/DashboardDataContext';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const ByTypeChart: React.FC = () => {
  const [data, setData] = useState<any>({ labels: [], datasets: [] });
  const { data: dash } = useDashboardData();
  useEffect(() => {
    if (!dash) return;
    if (dash.queriesByType && dash.queriesByType.length > 0) {
      const labels = dash.queriesByType.map(x => x.type);
      const counts = dash.queriesByType.map(x => x.count);
      setData({
        labels,
        datasets: [
          {
            label: 'Queries',
            data: counts,
            backgroundColor: [
              '#6366f1',
              '#f97316',
              '#22c55e',
              '#eab308',
              '#0ea5e9',
              '#ec4899',
              '#a855f7',
            ],
          },
        ],
      });
      return;
    }
    const map: Record<string, number> = {};
    (dash.queries || []).forEach((q: any) => {
      const t = q.type || 'Other';
      map[t] = (map[t] || 0) + 1;
    });
    const labels = Object.keys(map);
    const counts = labels.map(l => map[l]);
    setData({
      labels,
      datasets: [
        {
          label: 'Queries',
          data: counts,
          backgroundColor: [
            '#6366f1',
            '#f97316',
            '#22c55e',
            '#eab308',
            '#0ea5e9',
            '#ec4899',
            '#a855f7',
          ],
        },
      ],
    });
  }, [dash]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right' as const,
      },
    },
  };

  return (
    <div className="card">
      <h4 className="card-title">By Query Type</h4>
      <div className="chart-pie-sm">
        <Pie data={data} options={options} />
      </div>
    </div>
  );
};

export default ByTypeChart;
